import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class EmbeddedOnlyGuard implements CanActivate {

    constructor(
        private router: Router,
        private location: Location
    ) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const isInIframe = window.self !== window.top;

        const token = route.queryParams['token'];

        const storedToken = sessionStorage.getItem('embed_token');

        if ((isInIframe && token) || (storedToken && storedToken.length > 20)) {
            return true;
        }

        console.error('🚫 ACCESO DENEGADO: Chat solo disponible vía embebido');

        this.router.navigate(['/error'], {
            queryParams: {
                tipo: 'acceso-denegado',
                codigo: '403'
            }
        });


        return false;
    }
}
